<!-- TODO: сюда можно убрать логику по сканированию -->
<script setup lang="ts">
  import { Text, IconClose } from "@ui-kit";
  import { useOutsideClick } from "@src/hooks";
  import { PointerBarcodeButton, Background } from "@src/components";

  const { modal, helpButton } = defineProps<{
    modal?: {
      title?: string;
      subtitle?: string;
    };
    helpButton?: {
      title?: string;
      subtitle?: string;
    };
  }>();
  const emit = defineEmits<{ "close": [value: void] }>();

  const { handleClickOutside, elementRef } = useOutsideClick(() => emit("close"));
</script>

<template>
  <Background @click="handleClickOutside">
    <PointerBarcodeButton
      :text="helpButton?.title || $t('Нажмите кнопку сбоку,<br />чтобы отсканировать код')"
      :subText="helpButton?.subtitle || $t('или кнопку на RFID сканере')"
    />
    <div class="scan-screen__modal" ref="elementRef" data-testid="scan-screen-modal">
      <div class="scan-screen__header">
        <Text class="scan-screen__title" font="body-bold-16">{{ modal?.title || $t("Отсканируйте товар") }}</Text>
        <Text v-if="modal?.subtitle" font="body-regular-14" color="secondary">{{ modal?.subtitle }}</Text>
        <span class="scan-screen__close" @click="emit('close')" data-testid="scan-screen-btn-close">
          <IconClose style="width: 20px; height: 20px; stroke: var(--sf-base-icon-secondary)" />
        </span>
      </div>
      <div class="scan-screen__content">
        <slot />
      </div>
    </div>
  </Background>
</template>

<style scoped>
  :deep(.pointer-barcode-button) {
    margin-top: 215px;
  }

  .scan-screen__modal {
    display: flex;
    flex-direction: column;
    background-color: var(--sf-base-background-primary);
    padding: 16px;
    border-radius: 16px 16px 0 0;
    margin-top: auto;
    gap: 12px;
    position: relative;
  }

  .scan-screen__header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .scan-screen__title {
    margin: 3px 0;
  }

  .scan-screen__close {
    position: absolute;
    top: 16px;
    right: 16px;
    display: flex;
    border-radius: 100%;
    background-color: var(--sf-base-background-secondary);
    padding: 5px;
  }

  .scan-screen__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);
    padding: 20px 0 16px;
    min-height: 106px;
  }
</style>
